import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es";

import { Row, Col } from 'reactstrap';
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import styles from '../doctor/adminStyles.css';
import Input from '../../components/Input/Input';
import WYSIWYG from '../../components/WYSIWYG/WYSIWYG';
import FileUpload from '../../components/FileUpload/FileUpload';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import * as actions from "../../actions/ApiActions";
import connect from 'react-redux/es/connect/connect';

class RegisterSuccessContainer extends Component {


  render() {

    return (
      <Content>
        <Section>
          <div>
            <Headline center pageTitle>
              Willkommen bei Quickdoctor
            </Headline>
            <Headline center subtitle>Ihre Registrierung war erfolgreich. Bitte prüfen Sie Ihr Postfach und klicken Sie den Bestätigungslink in der von uns versendeten E-Mail.</Headline>

          </div>



        </Section>

      </Content>
    )
  }
}

export default RegisterSuccessContainer



// WEBPACK FOOTER //
// ./src/container/public/RegisterSuccessContainer.js